import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { UiAccordion } from "../../../components/common/UiAccordion";
import { UiCardTitle } from "../../../components/common/UiCardTitle";
import { UiContentCol, UiContentWr } from "../../../components/common/UiPageElements";
import { UiCol, UiRowContainer } from "../../../components/grid-container/GridContainer";
import { Accordion } from "react-bootstrap";
import { PlusIcon } from "../../../../../styles/img/svg/PlusIcon";

export const Faq = (props) => {

   
    return (
        <>
            <UiContentWr>
                <UiRowContainer fluid="fluid" className="sb-faq-wrapper sb-accordion-wrapper">
                    <Accordion defaultActiveKey={'0'} >
                        <Accordion.Item eventKey="0" key="0">
                            <UiCol lg="12" className={props.className}>
                                <UiContentCol>
                                    <div className="sb-first-accordion-header">
                                        <Accordion.Header>
                                            <UiCardTitle title="FAQs" /> <span className="sb-accordion-wrapper__plus"><PlusIcon /></span>
                                        </Accordion.Header>
                                    </div>
                                    <Accordion.Body>                                    
                                        <UiAccordion items={props.items} />
                                    </Accordion.Body>
                                </UiContentCol>
                            </UiCol>
                        </Accordion.Item>
                    </Accordion>
                </UiRowContainer>
            </UiContentWr>


        </>
    )
}